import {createGrid} from "../../../helpers/grids/grids";
import {createCellRenderer} from "../../../helpers/grids/helpers";
import createElement from "../../../helpers/createElement";
import {waitUntil} from "../../../helpers/waitUntil";
import {loading, stopLoading} from "../../../helpers/loading";
import Axios from "axios";
import handleAjaxError from "../../../helpers/handleAjaxError";
import {handleAjaxSuccess} from "../../../helpers/swalHelper";
import {setAsCurrencyField} from "../../../helpers/inputs/numbersOnlyInput/numbersOnlyInput";
import {getSingleInputByNameV3} from "../../../helpers/forms/formInputsHelpers";

function initProductionManagePayIndex() {

	// A list of rows that have been updated, keyed by their public id
	/** @var {Object<string,ProductionManagePayIndexDefs.UpdatedRowCacheEntry>} */
	const updatedRows = {};

	// noinspection JSValidateTypes
	/** @var {ProductionManagePayIndexDefs.ViewType} */
	const viewType = getSingleInputByNameV3(document.body, 'view_type');

	let rowName = 'Crew';

	switch (viewType) {
		case "cast":
			rowName = 'Actors';
			break;
		case "crew":
			rowName = 'Crew';
			break;
		default:
			console.error("Unknown view type ", viewType);
	}

	const grid = createGrid('.manage-pay-grid', {
			columnDefs: [
				{
					field: "full_name",
					headerName: 'Name',
					sortable: true,
					pinned: 'left',
					cellRenderer: createCellRenderer(params => {
						/** @var {Object<string,any>} */
						const request = params.data;
						if (request.audition_type === 'cast') {
							// noinspection JSUnresolvedReference
							return createElement(`
								<div style="line-height: 1">
									<div>${params.data.full_name}</div>
									<div class="small text-muted text-wrap py-1" title="Audition Type">${request.crew_type_string}</div>
									<div class="small text-muted text-wrap pb-1" title="Roles">${request.cast_roles_string}</div>
									<div class="small text-bold text-wrap pb-1">
										${params.data.declinedStipend ? '<span>(STIPEND DECLINED BY APPLICANT)</span>' : ''}
									</div>
								</div>
							`);
						} else {
							// noinspection JSUnresolvedReference
							return createElement(`
								<div style="line-height: 1">
									<div>${params.data.full_name}</div>
									<div class="small text-muted text-wrap py-1" title="Audition Type">${request.crew_type_string}</div>
									<div class="small text-bold text-wrap pb-1">
										${params.data.declinedStipend ? '<span>(STIPEND DECLINED BY APPLICANT)</span>' : ''}
									</div>
								</div>
							`);
						}
					}),
					minWidth: 230,
					maxWidth: 240,
					suppressAutoSize: true,
					autoHeight: true,
					sort: 'asc',
				},
				{
					field: 'stipend',
					cellClass: 'fill-space',
					flex: 1,
					minWidth: 120,
					maxWidth: 140,
					cellRenderer: createCellRenderer(params => {
						const row = params.data;
						// Retrieve initial value
						let stipendValue = params.data.stipend ? params.data.stipend : '';

						// Use locally cached value
						if (updatedRows[row.public_id]) {
							stipendValue = updatedRows[row.public_id].stipend;
						}

						const cell = createElement(`
							<div class="form-group my-0 h-100">
								<input
									id="stipend_${row.public_id}"
									name="stipend"
									value="${stipendValue}"
									class="form-control h-100 rounded-0"
									placeholder="Not Set"
									autocomplete="off"
								>
							</div>
						`)

						const input = cell.querySelector('input');

						setAsCurrencyField(input, {allowEmpty: true});

						input.addEventListener('change', () => {
							// noinspection JSUnresolvedReference -- Value from custom currency field input
							handleStipendChange(params.data, input.__custom__value)
						})

						return cell;
					}),
					suppressKeyboardEvent: () => {
						// Disable default tab behavior
						return true;
					}
				},
				{
					field: 'Paperwork Received',
					cellClass: 'fill-space',
					maxWidth: 200,
					cellRenderer: createCellRenderer(params => {
						/** @var {Object<string,any>} */
						const row = params.data;
						// Retrieve initial value
						let havePaperworkFlagValue = row.have_paperwork ? row.have_paperwork : '';

						// Use locally cached value
						if (updatedRows[row.public_id]) {
							// noinspection JSUnresolvedReference
							havePaperworkFlagValue = updatedRows[row.public_id].have_paperwork;
						}

						const cell = createElement(`
							<div class="form-group d-flex justify-content-center align-items-center my-0 h-100">
								<input
									id="have_paperwork_${row.public_id}"
									style="width: 20px"
									type="checkbox"
									name="have_paperwork"
									class="form-control paperwork_flag_input"
									placeholder="Not Set"
									autocomplete="off"
									${havePaperworkFlagValue ? 'checked' : ''}
								>
							</div>
						`)

						const input = cell.querySelector('input');

						input.addEventListener('change', () => {
							handleHavePaperWorkFlagChange(params.data, input.checked)
						})

						return cell;
					}),
					suppressKeyboardEvent: () => {
						// Disable default tab behavior
						return true;
					}
				},
				{
					field: 'Processed By Accounting',
					cellClass: 'fill-space',
					maxWidth: 220,
					cellRenderer: createCellRenderer(params => {
						/** @var {Object<string,any>} */
						const row = params.data;
						// Retrieve initial value
						let ProcessedByAccountingFlagValue = row.processed_by_accounting ? row.processed_by_accounting : '';

						// Use locally cached value
						if (updatedRows[row.public_id]) {
							// noinspection JSUnresolvedReference
							ProcessedByAccountingFlagValue = updatedRows[row.public_id].processed_by_accounting;
						}

						const cell = createElement(`
							<div class="form-group d-flex justify-content-center align-items-center my-0 h-100">
								<input
									id="processed_by_accounting_${row.public_id}"
									style="width: 20px"
									type="checkbox"
									name="processed_by_accounting"
									class="form-control processed_by_accounting_flag_input"
									placeholder="Not Set"
									autocomplete="off"
									${ProcessedByAccountingFlagValue ? 'checked' : ''}
								>
							</div>
						`)

						const input = cell.querySelector('input');

						input.addEventListener('change', () => {
							handleProcessedByAccountingFlagChange(params.data, input.checked)
						})

						return cell;
					}),
					suppressKeyboardEvent: () => {
						// Disable default tab behavior
						return true;
					}
				},
				{
					field: 'paperwork_notes',
					headerName: 'Notes',
					cellClass: 'fill-space',
					flex: 1,
					minWidth: 400,
					cellRenderer: createCellRenderer(params => {
						const row = params.data;
						// Retrieve initial value
						let paperworkNotes = params.data.paperwork_notes ? params.data.paperwork_notes : '';

						// Use locally cached value
						if (updatedRows[row.public_id]) {
							paperworkNotes = updatedRows[row.public_id].paperwork_notes;
						}

						const cell = createElement(`
							<div class="form-group my-0 h-100">
								<input
									id="paperwork_notes_${row.public_id}"
									name="paperwork_notes"
									value="${paperworkNotes}"
									class="form-control h-100 rounded-0"
									placeholder=""
									autocomplete="off"
								>
							</div>
						`)

						const input = cell.querySelector('input');

						input.addEventListener('change', () => {
							// noinspection JSUnresolvedReference -- Value from custom currency field input
							handlePaperWorkNotesChange(params.data, input.value)
						})

						return cell;
					}),
					suppressKeyboardEvent: () => {
						// Disable default tab behavior
						return true;
					}
				},
			],
			getRowClass: params => {
				if (hasRowBeenUpdated(params.data)) {
					return 'updated';
				}

				return '';
			},
			paginationPageSize: 500,
			cacheBlockSize: 500,
			_rowName: rowName,
		},
		window['routes/admin.productions.manage-pay.grid']
	);

	// Setup submit changes button
	const submitChangesButton = document.querySelector('.submit-button');
	if (submitChangesButton) {
		submitChangesButton.addEventListener('click', () => {
			submitChanges(submitChangesButton.dataset.route)
		})
	}

	/** Methods */

	/**
	 * Initializes
	 *
	 * @param row
	 * @return {ProductionManagePayIndexDefs.UpdatedRowCacheEntry}
	 */
	function getUpdatedRowCacheEntry(row) {
		if (!updatedRows[row.public_id]) {
			updatedRows[row.public_id] = {
				public_id: row.public_id,
				have_paperwork: row.have_paperwork,
				processed_by_accounting: row.processed_by_accounting,
				stipend: row.stipend ? parseFloat(row.stipend) : '',
				paperwork_notes: row.paperwork_notes ? row.paperwork_notes : '',
			};
		}

		return updatedRows[row.public_id];
	}

	function handleStipendChange(row, value) {
		const asFloat = parseFloat(value);

		const updatedRowEntry = getUpdatedRowCacheEntry(row);

		if (isNaN(asFloat)) {
			updatedRowEntry.stipend = '';
		} else {
			updatedRowEntry.stipend = asFloat;
		}

		refreshGridRows(row);
	}

	function handleHavePaperWorkFlagChange(row, value) {
		const updatedRowEntry = getUpdatedRowCacheEntry(row);

		updatedRowEntry.have_paperwork = value;

		refreshGridRows(row);
	}

	function handleProcessedByAccountingFlagChange(row, value) {
		const updatedRowEntry = getUpdatedRowCacheEntry(row);

		updatedRowEntry.processed_by_accounting = value;

		refreshGridRows(row);
	}

	function handlePaperWorkNotesChange(row, value) {
		const updatedRowEntry = getUpdatedRowCacheEntry(row);

		updatedRowEntry.paperwork_notes = value ? value : '';

		refreshGridRows(row);
	}

	// noinspection DuplicatedCode
	function refreshGridRows(rowData = undefined) {
		// Wait until the next element has focus
		waitUntil(() => document.querySelector(':focus'))
			.then(() => {
				// Then save which element it was...
				const previouslyFocusedElement = document.querySelector(':focus');

				if (rowData) {
					// ... redraw only given row ...
					const node = getRelatedRowNode(rowData);
					grid.api.redrawRows({
						rowNodes: [node],
					});
				} else {
					// ... redraw all rows ...
					grid.api.redrawRows();
				}

				// ... and wait until said element is back into the dom ...
				waitUntil(
					() => {
						return document.getElementById(previouslyFocusedElement.id)
					},
					{timeoutAfter: 2000}
				).then(() => {
					// ... then focus it
					document.getElementById(previouslyFocusedElement.id).focus();
				})

				// Also update change counter
				document.querySelector('.changes-counter').innerHTML = ` (${getChangedRows().length})`;
			})
	}

	function getChangedRows() {
		const changedRows = [];
		grid.api.forEachNode(node => {
			if (hasRowBeenUpdated(node.data)) {
				changedRows.push(updatedRows[node.data.public_id]);
			}
		})


		return changedRows;
	}

	function hasRowBeenUpdated(row) {
		const updatedRowCacheRecord = updatedRows[row.public_id];

		// If we don't even have a cache record, it has not been updated
		if (!updatedRowCacheRecord) {
			return false;
		}

		// Retrieve server stipend as float
		const serverStipendAsFloat = parseFloat(row.stipend);

		// Original server stipend
		const serverStipend = isNaN(serverStipendAsFloat) ? '' : serverStipendAsFloat;

		// Original server have paperwork flag
		const havePaperwork = row.have_paperwork;
		// Original server processed by accounting flag
		const processedByAccounting = row.processed_by_accounting;
		// Original server paperwork notes
		const paperworkNotes = row.paperwork_notes ? row.paperwork_notes : '';

		return (updatedRowCacheRecord.stipend !== serverStipend) || // If stipend was changed from server...
			(updatedRowCacheRecord.have_paperwork !== havePaperwork) || // ... or paperwork was ...
			(updatedRowCacheRecord.processed_by_accounting !== processedByAccounting) ||// or processed by accounting ...
			(updatedRowCacheRecord.paperwork_notes !== paperworkNotes) // or processed by accounting
	}

	// noinspection DuplicatedCode
	function submitChanges(route) {
		if (getChangedRows().length === 0) {
			// Do nothing
			return;
		}

		loading()

		Axios.post(route, {
			rows: getChangedRows(),
		})
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading);
	}

	/**
	 * @param rowData
	 * @return {import('ag-grid-community/dist/lib/interfaces/iRowNode').IRowNode}
	 */
	function getRelatedRowNode(rowData) {
		let relatedNode = null;
		grid.api.forEachNode(node => {
			if (relatedNode) {
				return;
			}

			if (node.data === rowData) {
				relatedNode = node;
			}
		})

		return relatedNode;
	}
}

export {
	initProductionManagePayIndex
}
